<div class="shop-footer">
  <div class="amway-container ">
    <div class="shop-footer-area">
      <div class="shop-f-content-call">
        <div class="shop-f-content-call-title">
          {{'FOOTER.need_help'|translate}}
        </div>
        <div class="shop-f-content-call-number">
          <div class="shop-f-content-call-number-area">
            <a href="tel:0-2725-8000"
              aria-label="telephone link">
              <div class="shop-f-cc-n-icon">
              </div>
            </a>
            <a href="tel:0-2725-8000"
              aria-label="telephone link"
              class="shop-f-cc-n-number">
              {{'FOOTER.phone'|translate}}
            </a>
          </div>
        </div>
      </div>
      <div class="shop-f-content-address">
        {{'FOOTER.company_address_1'|translate}}
        <br>
        {{'FOOTER.company_address_2'|translate}}
      </div>
      <div class="shop-f-content-logo-area">
        <div class="shop-f-content-logo">
        </div>
      </div>
      <div class="shop-f-content-copyright">{{'FOOTER.copyright'|translate}}</div>
    </div>
  </div>
</div>

<div class="padding-for-mobile"></div>

<div class="amway-dt-btn-bar-footer"></div>
